/**
 * Buyer-facing tax preview errors only — hide Stripe/platform setup messages.
 */
const BUYER_MESSAGES = {
  TAX_ADDRESS_REQUIRED: "Add your country in My Profile to estimate tax.",
  AUTH_REQUIRED: "Log in to preview your order total.",
};

export function resolveBuyerTaxPreviewError(code, message) {
  if (code && BUYER_MESSAGES[code]) {
    return BUYER_MESSAGES[code];
  }

  if (message && /country.*profile|billing address|TAX_ADDRESS/i.test(message)) {
    return BUYER_MESSAGES.TAX_ADDRESS_REQUIRED;
  }

  if (message) {
    console.warn("[tax preview]", message);
  }

  return null;
}

export function isStripePlatformTaxError(code, message) {
  if (code === "STRIPE_TAX_ERROR") return true;
  const text = String(message || "").toLowerCase();
  return (
    text.includes("stripe tax has not been activated") ||
    text.includes("dashboard.stripe.com") ||
    text.includes("tax not configured")
  );
}
